import React, { useEffect, useRef, useState } from "react";
import popup, { answerPopup } from "./popup";
import { FARAL, FLOWERS } from "./desiAssets";

/** Bengal (click2win.php) and Maharashtra (click2win2.php): two attempts to tap the right picture. */
const CONFIG = {
  bengal: { images: FLOWERS, correct: 2, answer: "HIBISCUS", cols: 5, rows: 1, max: 760, colsMob: 3 },
  maharashtra: { images: FARAL, correct: 5, answer: "SHEERA", cols: 3, rows: 3, max: 540, colsMob: 3 },
};

export default function ClickToWin({ gameKey, api }) {
  const cfg = CONFIG[gameKey];
  const { initialState, saveProgress, setScore, submit, setReveal } = api;
  // Attempts survive a refresh (saved state: { attempts, solved }), so a reload is not a free retry.
  const attemptsRef = useRef(Number(initialState?.attempts) || 0);
  const resumedRef = useRef(false);
  const [busy, setBusy] = useState(false);

  // Skip shows the right answer before the (zero) score is saved.
  useEffect(() => {
    setReveal(() =>
      answerPopup({ correct: false, answer: cfg.answer, title: "The answer", text: "The correct answer is", icon: null })
    );
    return () => setReveal(null);
  }, [setReveal, cfg.answer]);

  useEffect(() => {
    if (resumedRef.current || !initialState) return;
    resumedRef.current = true;
    // Refreshed while the result popup was open: finish the game with the result already reached.
    if (initialState.solved) {
      setBusy(true);
      setScore(1);
      submit(1);
    } else if (attemptsRef.current >= 2) {
      setBusy(true);
      submit(0);
    }
  }, [initialState, setScore, submit]);

  const pick = async (pos) => {
    if (busy || api.saving) return;
    attemptsRef.current += 1;
    setBusy(true);
    saveProgress({ attempts: attemptsRef.current, solved: pos === cfg.correct });

    if (pos === cfg.correct) {
      api.setScore(1);
      await answerPopup({ correct: true, answer: cfg.answer, title: "You got it right!", text: "The answer is" });
      await api.submit(1);
    } else if (attemptsRef.current < 2) {
      await popup.fire({
        icon: "warning",
        title: "Not quite!",
        text: "You have only one attempt left. Choose carefully.",
        confirmButtonText: "Try again",
      });
    } else {
      await answerPopup({ correct: false, answer: cfg.answer, title: "Better luck next time", text: "The answer is" });
      await api.submit(0);
    }
    setBusy(false);
  };

  return (
    <div
      className="desi-tiles"
      style={{
        "--cols-desk": cfg.cols,
        "--cols-mob": cfg.colsMob,
        "--rows": cfg.rows,
        "--max": `${cfg.max}px`,
      }}
    >
      {cfg.images.map((src, i) => (
        <button
          key={src}
          type="button"
          className="desi-tile"
          disabled={busy}
          onClick={() => pick(i + 1)}
        >
          <img src={src} alt={`Option ${i + 1}`} draggable={false} />
        </button>
      ))}
    </div>
  );
}
